package br.com.vvrefeicoes.portal.feature.auth.forgotPassword

import androidx.compose.runtime.Composable

@Composable
fun ForgotPasswordScreen(
    onBack: () -> Unit,
    onPasswordChanged: () -> Unit,
    initialEmail: String = "",
) {
    val controller = rememberForgotPasswordController(onBack, onPasswordChanged, initialEmail)
    ForgotPasswordLayout(controller)
}
